var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaucepan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.666,
    y: 10,
    width: 6.667,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 6.666,
    height: 16.667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.333,
    y: 10,
    width: 6.667,
    height: 16.667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.667,43.333v-6.667H60c0-5.524-4.479-10-10-10c-5.524,0-10,4.476-10,10H13.333v6.667H20V50h-6.667v6.667H20V80 c0,5.501,4.498,10,10,10h40c5.501,0,10-4.499,10-10V56.667h6.667V50H80v-6.667H86.667z M50,33.333c1.839,0,3.333,1.491,3.333,3.333 h-6.667C46.666,34.824,48.157,33.333,50,33.333z M73.333,80c0,1.807-1.526,3.333-3.333,3.333H30c-1.807,0-3.334-1.526-3.334-3.333 V43.333h46.667V80z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaucepan);
export default __webpack_public_path__ + "static/media/saucepan.b20a3467c64d1dc6f8c8725e70d63bc9.svg";
export { ForwardRef as ReactComponent };